module.exports = __webpack_public_path__ + "media/images/countryrect/lr-9d8ecf5a4de3ae47028fffbb14d1f750.svg";